import { XHR } from './../XHR';

export class Request {

    constructor() {
        this.request = new XHR;
    }

    get(url) {
        return this.request.get(
            url
        );
    }

    post(url, params) {
        return this.request.post(
            url,
            params
        );

        //request.then(function(resp) {
        //    switch (resp.statusCode) {
        //        case 0:
        //            document.getElementById('success').classList.add('slow');
        //            break;
        //        case 2:
        //        case 400:
        //            document.getElementById('service-down').classList.add('slow');
        //            break;
        //        default:
        //    }
        //});
    }
}



// WEBPACK FOOTER //
// ./src/modules/Shared/Request/index.js